<template>
    <div class="container">
        <Header/>
        <div class="top_switch">
            <el-radio-group v-model="topSwitchCurrent" @change="onRadioChange">
                <el-radio-button label="训练"></el-radio-button>
                <el-radio-button label="暑期训练"></el-radio-button>
                <el-radio-button label="强基"></el-radio-button>
            </el-radio-group>
<!--            <div class="top_card">-->
<!--                <img class="top_card_img" src="../assets/images/card_samll_icon.png"/>-->
<!--                <div class="top_card_text" @click="showCardDialog">我的卡包</div>-->
<!--            </div>-->
        </div>

        <div class="subjectBox">
            <template v-for="(item,i) in initData">
                <div class="sub_english subject" :key="i" :class="item.isAuth !== 1 ? 'gray' : ''"
                     v-if="item.name === '智能英语'">
                    <div class="float_des_div" v-if="item.authDesc"><img class="float_des_img" src="../assets/images/info_circle.png"/>{{item.authDesc}}</div>
                    <img @click="goToHome(item.id,item.isAuth)" class="img" style="width: 228px; height: 281px" :src="item.imgUrl"/>
                </div>
                <div class="sub_yuwen subject" :key="i" :class="item.isAuth !== 1 ? 'gray' : ''"
                     v-if="item.name === '智能语文'">
                    <div class="float_des_div" v-if="item.authDesc"><img class="float_des_img" src="../assets/images/info_circle.png"/>{{item.authDesc}}</div>
                    <img @click="goToHome(item.id,item.isAuth)" class="img" style="width: 228px; height: 281px" :src="item.imgUrl"/>
                </div>
                <div class="sub_kexue subject" :key="i" :class="item.isAuth !== 1 ? 'gray' : ''"
                     v-if="item.name === '智能科学'">
                    <div class="float_des_div" v-if="item.authDesc"><img class="float_des_img" src="../assets/images/info_circle.png"/>{{item.authDesc}}</div>
                    <img @click="goToHome(item.id,item.isAuth)" class="img" style="width: 228px; height: 182px" :src="item.imgUrl"/>
                </div>
                <div class="sub_wuli subject" :key="i" :class="item.isAuth !== 1 ? 'gray' : ''"
                     v-if="item.name === '智能物理'">
                    <div style="top: 158px" class="float_des_div" v-if="item.authDesc"><img class="float_des_img" src="../assets/images/info_circle.png"/>{{item.authDesc}}</div>
                    <img @click="goToHome(item.id,item.isAuth)" class="img" style="width: 228px; height: 182px" :src="item.imgUrl"/>
                </div>
                <div class="sub_huaxue subject" :key="i" :class="item.isAuth !== 1 ? 'gray' : ''"
                     v-if="item.name === '智能化学'">
                    <div class="float_des_div" v-if="item.authDesc"><img class="float_des_img" src="../assets/images/info_circle.png"/>{{item.authDesc}}</div>
                    <img @click="goToHome(item.id,item.isAuth)" class="img" style="width: 228px; height: 182px"
                         :src="item.imgUrl"/>
                </div>
                <div class="sub_shuxue subject" :key="i" :class="item.isAuth !== 1 ? 'gray' : ''"
                     v-if="item.name === '智能数学'">
                    <div class="float_des_div" v-if="item.authDesc"><img class="float_des_img" src="../assets/images/info_circle.png"/>{{item.authDesc}}</div>
                    <img @click="goToHome(item.id,item.isAuth)" class="img" style="width: 228px; height: 380px" :src="item.imgUrl"/>
                </div>
                <div class="sub_shengwu subject" :key="i" :class="item.isAuth !== 1 ? 'gray' : ''"
                     v-if="item.name === '智能生物'">
                    <div class="float_des_div" v-if="item.authDesc"><img class="float_des_img" src="../assets/images/info_circle.png"/>{{item.authDesc}}</div>
                    <img @click="goToHome(item.id,item.isAuth)" class="img" style="width: 228px; height: 182px" :src="item.imgUrl"/>
                </div>
                <div class="sub_dili subject" :key="i" :class="item.isAuth !== 1 ? 'gray' : ''"
                     v-if="item.name === '智能地理'">
                    <div class="float_des_div" v-if="item.authDesc"><img class="float_des_img" src="../assets/images/info_circle.png"/>{{item.authDesc}}</div>
                    <img @click="goToHome(item.id,item.isAuth)" class="img" style="width: 228px; height: 182px" :src="item.imgUrl"/>
                </div>
                <div class="sub_lishi subject" :key="i" :class="item.isAuth !== 1 ? 'gray' : ''"
                     v-if="item.name === '智能历史'">
                    <div class="float_des_div" v-if="item.authDesc"><img class="float_des_img" src="../assets/images/info_circle.png"/>{{item.authDesc}}</div>
                    <img @click="goToHome(item.id,item.isAuth)" class="img" style="width: 228px; height: 182px" :src="item.imgUrl"/>
                </div>
                <div class="sub_zhengzhi subject" :key="i" :class="item.isAuth !== 1 ? 'gray' : ''"
                     v-if="item.name === '智能政治'">
                    <div class="float_des_div" v-if="item.authDesc"><img class="float_des_img" src="../assets/images/info_circle.png"/>{{item.authDesc}}</div>
                    <img @click="goToHome(item.id,item.isAuth)" class="img" style="width: 228px; height: 182px" :src="item.imgUrl"/>
                </div>
            </template>
        </div>
        <div class="footer">
            <div class="footer-left">
                <div class="nav">
                    <!-- <router-link to="errorCounseling"> -->
                    <span @click="goToErrorCounseling" class="footer-subject">错题辅导</span>
                    <!-- </router-link> -->
                    <span class="footer-icon1">
            <router-link to="errorCounseling">
              <!-- <i class="iconfont icon-compasszhinanzhen"></i> -->
              <i class="iconfont foot-icon">&#xe632;</i>
            </router-link>
          </span>
                </div>
                <div class="nav2">
                    <span @click="showModal = true" class="footer-subject">错题本</span>
                    <span class="footer-icon1">
            <i @click="showModal = true" class="iconfont foot-icon">&#xe62e;</i>
          </span>
                    <div class="mask" v-if="showModal" @click="showModal = false"></div>
                    <div class="pop1" v-show="showModal">
                        <div class="echarts">
                            <!-- <chart /> -->
                            <div id="myChart" :style="{ width: '520px'}"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer-right">
                <div class="nav3">
          <span class="footer-icon1">
            <i @click="showModa2 = true" class="iconfont foot-icon">&#xe62b;</i>
          </span>
                    <span class="footer-subject1" @click="showModa2 = true">我的任务</span>
                    <div class="mask" v-if="showModa2" @click="showModa2 = false"></div>
                    <div class="pop" v-if="showModa2">
                        <div class="taskes">
                            <happy-scroll size="8" resize right style="height:auto; width: 565px;">
                                <div class="taske">
                                    <div class="taske_left">
                                        <!-- <div class="title">智能语文</div> -->
                                        <div class="nav" v-for="(item,index) in myTaskList" :key="index">
                                            <div class="mytesk" v-if="item.vaildFlag == 1" @click="goMyTask(item.taskId, item.taskName)">
												<span class="taske1">{{item.subjectName}}</span>
												<span class="taske2">{{ item.taskName }}</span>
												<span v-if="item.curLevel || item.target" class="taske2"> (</span>
												<span class="taske2" style="color: black">{{ item.curLevel ? `当前：${item.curLevel}` : ''}}</span>
												<span class="taske2" style="color: black">{{ item.target ? `目标: ${item.target}`: '' }}</span>
												<span v-if="item.curLevel || item.target" class="taske2"> )</span>
											</div>
                                            <div class="mytesk" style="cursor:default!important;" v-if="item.vaildFlag == 0">
                                                <span class="taske1">{{item.subjectName}}</span>
                                                <span class="taske2" style="text-decoration:line-through;">{{ item.taskName }}</span>
                                                <span v-if="item.curLevel || item.target" class="taske2"> (</span>
                                                <span class="taske2" style="text-decoration:line-through;color: black">{{ item.curLevel ? `当前：${item.curLevel}` : ''}}</span>
                                                <span class="taske2" style="text-decoration:line-through;color: black">{{ item.target ? `目标: ${item.target}`: '' }}</span>
                                                <span v-if="item.curLevel || item.target" class="taske2"> )</span>
												<span style="color: red;padding-left: 5px;">科目卡已过期</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </happy-scroll>
                        </div>
                    </div>
                </div>
                <div class="nav4">
          <span class="footer-icon1">
            <router-link to="viewingHistory">
              <i class="iconfont foot-icon">&#xe62d;</i>
            </router-link>
          </span>
                    <router-link to="viewingHistory">
                        <span class="footer-subject1">查看历史任务</span>
                    </router-link>
                </div>
            </div>
        </div>
        <el-dialog title="我的卡包" :visible.sync="dialogTableVisible">
            <el-tabs v-model="classCardTabValue" @tab-click="handleClassCardTabsClick">
                <el-tab-pane label="普通课时卡" name="commonClassCard">
                    <div class="default_card">
                        <img class="default_card_img" src="../assets/images/class_card_default_bg.png">
                        <div class="default_card_text">您还没有课时卡</div>
                        <div class="default_card_bottom">查看课时卡使用记录</div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="通用课时卡" name="selectClassCard">
                    <div class="default_card">
                        <img class="default_card_img" src="../assets/images/class_card_default_bg.png">
                        <div class="default_card_text">您还没有课时卡</div>
                        <div class="default_card_bottom">查看课时卡使用记录</div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>
    </div>
</template>

<script>
    import Header from "../components/common/Header";
    import chart from "../components/chart/chart";
    import api from "../axios/interface";

    export default {
        name: "Home",
        data() {
            return {
                message: "页面加载于 " + new Date().toLocaleString(),
                resultData: [], //初始数据
                showModal: false,
                showModa2: false,
                TopicData: [],
                myTaskList: [],
                initData: [
                    {id: "", name: "", isAuth: 0, imgUrl: ""}],
                errorData: [],
                topSwitchCurrent: '训练',
                dialogTableVisible: false,
                classCardTabValue: 'commonClassCard'
            };
        },
        components: {
            Header: Header,
            chart: chart
        },
        mounted() {
            this.getSubjectData();
            this.getWrongStatistics();
            this.getMyTaskList();
        },
        methods: {
            showCardDialog() {
                this.dialogTableVisible = true;
            },
            handleClassCardTabsClick() {
                console.log("tab==", this.classCardTabValue);
            },
            onRadioChange(label) {
                if (label === '训练') {
                    this.getSubjectData();
                } else if (label === '暑期训练') {
                    this.getVacationSubjectData();
                } else {
                    this.getConsolidatedSubject();
                }
            },
            // 获取科目权限
            getSubjectData() {
                let that = this;
                this.$axios.get(api.GetSubject, {}, {hideMessage: true})
                    .then(res => {
                        if (res.result) {
                            that.initData = res.result.data;
                        }
                    });
            },

            // 获取暑期科目权限
            getVacationSubjectData() {
                let that = this;
                this.$axios.get(api.GetVacationSubject, {}, {hideMessage: true})
                    .then(res => {
                        if (res.result) {
                            that.initData = res.result.data;
                        }
                    });
            },

            // 获取强基科目权限
            getConsolidatedSubject() {
                let that = this;
                this.$axios.get(api.getConsolidatedSubject, {}, {hideMessage: true})
                    .then(res => {
                        if (res.result) {
                            that.initData = res.result.data;
                        }
                    });
            },

            goToHome(id, isAuth) {
                let that = this;
                if (isAuth === 1) {
                    that.$router.push({
                        path: "/subjecthome", //跳转路由
                        query: {
                            subjectId: id
                        }
                    });
                }
            },

            // 获取错题本数据统计接口
            getWrongStatistics() {
                this.$axios.get(api.GetWrongStatistics, {}, {hideMessage: true})
                    .then(res => {
                        this.errorData = res.result.data;
                        this.drawLine();
                    })
                    .catch(res => {
                    });
            },

            getMyTaskList() {
                this.$axios.get(api.HistorMyTaskList, {}, {hideMessage: true})
                    .then(res => {
                        this.myTaskList = res.result.data;
                    })
                    .catch(res => {
                    });
            },

            goMyTask(taskid, taskName) {
                // type 1 为科目主页的挑战； type: 2 为我的任务挑战
				let rName = '词汇积累'.indexOf(taskName)>-1 ? 'enchallenge' : 'challenge'
                this.$router.push({
                    name: rName,
                    query: {type: 2, taskId: taskid, subjectId: this.subjectId}
                });
            },

            goToErrorCounseling() {
                this.$router.push({
                    name: "ErrorCounseling",
                    query: {}
                });
            },

            // 绘制echart
            drawLine() {
                // 基于准备好的dom，初始化echarts实例
                let dom = document.getElementById("myChart");
                dom.style.height = (this.errorData.length * 20 + 80) + "px";
                let myChart = this.$echarts.init(dom);
                // 分解数据
                let subjectData = this.errorData.map(item => {
                    return item.name;
                });
                let wrongNums = this.errorData.map(item => {
                    return item.wrongNum;
                });
                let rightNums = this.errorData.map(item => {
                    return item.rightNum;
                });
                // 绘制图表
                myChart.setOption({
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            // 坐标轴指示器，坐标轴触发有效
                            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    legend: {
                        data: ["错误", "正确"]
                    },
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "3%",
                        containLabel: true
                    },
                    xAxis: {
                        type: "value"
                    },
                    yAxis: {
                        type: "category",
                        // data: [ "历史", "政治", "地理", "生物", "化学", "物理", "科学", "数学", "语文", "英语"]
                        data: subjectData
                    },
                    series: [
                        {
                            name: "错误",
                            type: "bar",
                            stack: "总量",
                            label: {
                                show: true,
                                position: "insideRight",
                                formatter: function (params) {
                                    if (params.value > 0) {
                                        return params.value;
                                    } else {
                                        return "";
                                    }
                                }
                            },
                            // data: [320, 302, 301, 334, 390, 330, 320, 550, 520, 630]
                            data: wrongNums
                        },
                        {
                            name: "正确",
                            type: "bar",
                            stack: "总量",
                            label: {
                                show: true,
                                position: "insideRight",
                                formatter: function (params) {
                                    if (params.value > 0) {
                                        return params.value;
                                    } else {
                                        return "";
                                    }
                                }
                            },
                            // data: [320, 302, 301, 334, 390, 330, 320, 550, 520, 630]
                            data: rightNums
                        }
                    ]
                });
            }
        }
    };
</script>

<style lang='less' scoped>
    .top_switch {
        display: flex;
        width: 960px;
        flex: 1;
        flex-direction: row;
        justify-content: space-between;
        margin: 70px 0 0 20px;
    }

    .top_card {
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
    }

    .top_card_img {
        width: 16px;
        height: 16px;
        margin-right: 4px;
    }

    .top_card_text {
        font-size: 14px;
        color: #999999;
    }

    .default_card {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .default_card_img {
        width: 128px;
        height: 128px;
        margin-top: 97px;
    }

    .default_card_text {
        font-size: 24px;
        color: #EEEEEE;
        margin-top: 24px;
    }

    .default_card_bottom {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 32px;
        border-radius: 15px;
        padding: 0 24px;
        color: #999999;
        font-size: 12px;
        border: solid #999999 1px;
        margin-top: 104px;
    }




    /* 中间开始 */
    .subjectBox {
        width: 960px;
        height: 578px;
        // min-height: 780px;
        margin: 50px 0 200px 20px;
        position: relative;

        .subject {
            img {
                border-radius: 4px;
            }
        }

        .gray {
            img {
                /*grayscale(val):val值越大灰度就越深*/
                -webkit-filter: grayscale(100%);
                -moz-filter: grayscale(100%);
                -ms-filter: grayscale(100%);
                -o-filter: grayscale(100%);
                filter: grayscale(100%);
                filter: gray;
                opacity: 0.5;
            }
        }

        .sub_english {
            width: 228px;
            height: 281px;
            position: absolute;
            left: 0;
            top: 0;

        }

        .float_des_div {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            height: 24px;
            background: rgba(0, 0, 0, 0.5);
            color: #FFFFFF;
            font-size: 13px;
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            z-index: 999;
        }

        .float_des_img {
            width: 20px;
            height: 20px;
            margin-right: 4px;
        }

        .sub_yuwen {
            width: 228px;
            height: 281px;
            position: absolute;
            left: 0;
            top: 297px;
        }

        .sub_kexue {
            width: 228px;
            height: 182px;
            position: absolute;
            top: 0;
            left: 244px;
        }

        .sub_wuli {
            width: 228px;
            height: 282px;
            position: absolute;
            top: 198px;
            left: 244px;
        }

        .sub_huaxue {
            width: 228px;
            height: 182px;
            position: absolute;
            left: 244px;
            top: 396px;
        }

        .sub_shuxue {
            width: 228px;
            height: 380px;
            position: absolute;
            top: 0;
            left: 488px;
        }

        .sub_shengwu {
            width: 228px;
            height: 182px;
            position: absolute;
            bottom: 0;
            top: 396px;
            left: 488px;
        }

        .sub_dili {
            width: 228px;
            height: 182px;
            position: absolute;
            left: 732px;
            top: 0;
        }

        .sub_lishi {
            width: 228px;
            height: 182px;
            position: absolute;
            left: 732px;
            top: 198px;
        }

        .sub_zhengzhi {
            width: 228px;
            height: 182px;
            position: absolute;
            left: 732px;
            top: 396px;
        }
    }

    /* 中间结束 */
    /* 底部开始 */
    .footer {
        width: 1200px;
        height: 60px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        margin: 0 auto;
        position: fixed;
        bottom: 0;
        z-index: 9999;
    }

    .footer .footer-left {
        width: 600px;
        height: 60px;
        display: flex;
        color: #fff;
        background-color: #797979;
        border-top-left-radius: 10px;
    }

    .footer .footer-right {
        width: 600px;
        height: 60px;
        display: flex;
        background-color: #3b99f5;
        border-top-right-radius: 10px;
    }

    .footer .footer-left .nav {
        width: 200px;
        height: 60px;
        display: flex;
    }

    .footer .footer-left .nav2 {
        width: 200px;
        height: 60px;
        display: flex;
        margin-left: 200px;
    }

    .footer .footer-right .nav3 {
        width: 200px;
        display: flex;
    }

    .footer .footer-right .nav4 {
        width: 200px;
        height: 60px;
        display: flex;
        text-align: center;
        margin-left: 160px;
    }

    .footer .footer-left .nav .footer-subject {
        width: 65px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        margin-left: 50px;
        cursor: pointer;
    }

    .footer .footer-left .nav2 .footer-icon1 {
        width: 30px;
    }

    .foot-icon {
        color: #ffffff;
        font-size: 30px;
        cursor: pointer;
    }

    .footer .footer-left .nav2 .footer-subject {
        width: 65px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        margin-left: 50px;
        cursor: pointer;
    }

    .footer .footer-right .nav3 .footer-icon1 {
        width: 30px;
        margin-left: 50px;
    }

    .footer .footer-right .nav3 .footer-subject1 {
        width: 65px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        padding-left: 10px;
        color: #fff;
        cursor: pointer;
    }

    .footer .footer-right .nav4 .footer-icon1 {
        width: 30px;
        margin-left: 50px;
    }

    .footer .footer-right .nav4 .footer-subject1 {
        height: 60px;
        text-align: center;
        line-height: 60px;
        padding-left: 10px;
        color: #fff;
        cursor: pointer;
    }

    .footer .footer-right .nav4 .footer-icon1 {
        width: 30px;
    }

    .footer-icon1 {
        width: 50px;
        display: block;
        text-align: center;
        margin-top: 15px;
    }

    .footer-img {
        width: 30px;
        height: 30px;
    }

    /* 底部结束 */
    .mask {
        opacity: 0.3;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
    }

    /* 左边echarts图表分析区域开始*/
    .pop1 {
        background-color: #fff;
        position: fixed;
        border-radius: 10px;
        bottom: 60px;
        left: 362px;
        width: 600px;
        // height: 312px;
        z-index: 2;
        opacity: 0.8;
    }

    .pop1 .echarts {
        width: 520px;
        height: auto;
        margin: 30px 30px 0 30px;
        z-index: -10;
    }

    /* 左边echarts图表分析区域end*/
    /* 右边做任务区域开始 */
    .pop .taskes {
        // height: 261px;
        margin: 30px 20px 30px 20px;
        z-index: -1;
    }

    .pop {
        background-color: #fff;
        position: fixed;
        border-radius: 10px;
        bottom: 60px;
        width: 600px;
        // height: 312px;
        z-index: 2;
        opacity: 0.8;
    }

    .pop .taskes .taske {
        display: flex;
        flex-direction: row;
    }

    /* 做任务语文区域开始 */
    .taskes .taske_left {
    }

    .title {
        width: 270px;
        height: 20px;
        font-size: 15px;
        color: #4d4d4d;
    }

    .taskes .taske_left .nav {
        display: flex;
        flex-direction: row;
        height: 20px;
        line-height: 20px;
        margin-top: 5px;
        font-size: 12px;
    }

    /* 做任务语文区域end */
    /* 做任务英语区域开始 */
    .taskes .taske_right {
        margin-left: 15px;
    }

    .mytesk {
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 16px;
    }

    .taskes .taske_left .nav .taske1 {
        height: 18px;
        line-height: 18px;
        border-radius: 5px;
        border: 1px solid #0079fe;
        color: #fff;
        text-align: center;
        display: inline-block;
        background-color: #0079fe;
        padding: 2px 4px;
        margin-right: 4px;
    }

    .taskes .taske_left .nav .taske2 {
        height: 16px;
        line-height: 16px;
        margin-left: 5px;
        color: #9b9b9b;
        flex-wrap: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 4px;
    }

    .taskes .taske_right .nav1 {
        display: flex;
        flex-direction: row;
        height: 20px;
        line-height: 20px;
        margin-top: 5px;
        font-size: 12px;
    }

    .nav1 .taske1 {
        height: 18px;
        line-height: 18px;
        border-radius: 5px;
        border: 1px solid #0079fe;
        color: #fff;
        text-align: center;
        background-color: #0079fe;
        padding: 2px 4px;
        margin-right: 4px;
    }

    .nav1 .taske2 {
        height: 16px;
        line-height: 16px;
        margin-left: 5px;
        color: #9b9b9b;
        flex-wrap: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 4px;
    }

    /* 右边做任务区域开始end */
</style>
